quickviewService.$inject = ["modalService", "$location", "$timeout", "urlHelper"];
import quckviewModalTemplate from '../templates/quckviewModal.html';
/* @ngInject */
function quickviewService(modalService, $location, $timeout, urlHelper) {
  var service = this,
    isRender = false,
    modalQuickViewId = null,
    modalsStorage = {},
    data = {},
    needOpenDialogId,
    dialogIdOpen;
  service.dialogRender = function (parentScope) {
    modalService.renderModal(modalQuickViewId || 'modalQuickView', null, "<div data-ng-include=\"'".concat(quckviewModalTemplate, "'\"></div>"), null, {
      'isOpen': false,
      'modalClass': 'modal-quickview' + ' ' + (parentScope.modalClass || ''),
      'backgroundEnable': true,
      spyAddress: parentScope.spyAddress,
      anchor: modalQuickViewId || 'modalQuickView',
      callbackOpen: parentScope.spyAddress ? 'quickview.onOpenModalCallback()' : '',
      callbackClose: 'quickview.onModalClose()'
    }, {
      quickview: parentScope
    });
    modalService.getModal(modalQuickViewId || 'modalQuickView').then(function (modal) {
      modal.modalScope.open();
    });
  };
  service.getUrl = function (productId, colorId, typeView, landingId, hideShipping, showLeadButton, blockId, showVideo, sizeId, descriptionMode) {
    return 'product/productquickview' + '?productId=' + productId + (colorId != null ? '&color=' + colorId : '') + (sizeId != null ? '&size=' + sizeId : '') + '&from=' + typeView + (landingId != null ? '&landingId=' + landingId : '') + (hideShipping != null ? '&hideShipping=' + hideShipping : '') + (showLeadButton != null ? '&showLeadButton=' + showLeadButton : '') + (blockId != null ? '&blockId=' + blockId : '') + (showVideo != null ? '&showVideo=' + showVideo : '') + (descriptionMode != null ? '&descriptionMode=' + descriptionMode : '');
  };
  service.dialogOpen = function (itemData, productId, colorId, typeView, modalClass, landingId, hideShipping, showLeadButton, blockId, showVideo, modalId, openFromHash, sizeId, onOpenModalCallback, spyAddress, descriptionMode) {
    dialogIdOpen = modalId;
    data.url = service.getUrl(productId, colorId, typeView, landingId, hideShipping, showLeadButton, blockId, showVideo, sizeId, descriptionMode);
    data.itemData = itemData;
    data.productId = productId;
    data.next = service.next;
    data.prev = service.prev;
    data.modalClass = modalClass;
    data.typeView = typeView;
    data.landingId = landingId;
    data.hideShipping = hideShipping;
    data.showLeadButton = showLeadButton;
    data.blockId = blockId;
    data.showVideo = showVideo;
    data.modalId = modalId;
    data.onOpenModalCallback = onOpenModalCallback;
    data.spyAddress = spyAddress;
    data.descriptionMode = descriptionMode;
    data.onModalClose = () => {
      $location.search({
        color: undefined,
        size: undefined
      });
      //remove hash
      history.pushState(null, document.title, location.pathname + location.search);
      dialogIdOpen = null;
    };
    modalQuickViewId = modalId;
    var hash = $location.hash();
    var splitedHash = hash.split('?');
    var originalHash = splitedHash[0];
    if (!modalsStorage[modalId]) {
      service.dialogRender(data);
    } else {
      modalService.open(modalId);
    }
    modalsStorage[modalId] = modalId;
    if (modalId != null) {
      $timeout(() => $location.hash(modalId), 100);
    }
    service.removeNeedOpenDialog();
  };
  service.dialogClose = function () {
    modalService.close(modalQuickViewId || 'modalQuickView');
    dialogIdOpen = null;
  };
  service.goTo = function (index) {
    if (data.itemData.siblings[index] != null) {
      data.productId = data.itemData.siblings[index];
      if (data.itemData.modalIds[data.productId] != null) {
        $location.hash(data.itemData.modalIds[data.productId]);
      }
      $location.search({
        color: undefined,
        size: undefined
      });
      data.url = service.getUrl(data.productId, null, data.typeView, data.landingId, data.hideShipping, data.showLeadButton, data.blockId, data.showVideo, null, data.descriptionMode);
    }
  };
  service.prev = function () {
    service.goTo(data.itemData.siblings.indexOf(data.productId) - 1);
  };
  service.next = function () {
    service.goTo(data.itemData.siblings.indexOf(data.productId) + 1);
  };
  service.dialogIsExist = function (modalQuickViewId) {
    return modalService.hasModal(modalQuickViewId) || needOpenDialogId != null;
  };
  service.checkDialogOpenById = function (modalQuickViewId) {
    return dialogIdOpen === modalQuickViewId;
  };
  service.needOpenDialog = function (modalQuickViewId) {
    needOpenDialogId = modalQuickViewId;
  };
  service.removeNeedOpenDialog = function () {
    needOpenDialogId = null;
  };
}
;
export default quickviewService;